<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">应急组织结构</div>
      <el-form class="zj-search-form" ref="form" :model="form">
        <el-form-item label="所属应急组织类型">
          <el-select v-model="organizationType" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.code"
              :label="item.value"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应急组织名称" prop="name">
          <el-input v-model="name"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main style="padding-top:0px;">
      <zj-layout-container>
        <zj-layout-header>
          <div class="zj-button-bar">
            <el-button size="mini" @click="onAdd">添 加</el-button>
            <el-button size="mini" @click="onbatchDel">删 除</el-button>
          </div>
        </zj-layout-header>
        <zj-layout-main style="padding:0.8rem 0px 0px 0px;">
          <el-table
            :data="tableData"
            ref="multipleTable"
            @selection-change="selectionChange"
            border
            style="width: 100%"
            height="100%"
          >
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="应急组织名称" align="center"></el-table-column>
            <el-table-column prop="organizationTypeTranslated" label="所属应急组织类型" align="center"></el-table-column>
            <el-table-column prop="organizationNatureTranslated" label="组织性质" align="center"></el-table-column>
            <el-table-column label="操作" width="130" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </zj-layout-main>
      </zj-layout-container>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { list, remove } from "@/api/src/emergency_organization";
import { list as personList } from "@/api/src/emergency_person";

export default {
  name: "ZjPersonOrganiztionlist",
  controller: "EmergencyResource",
  action: "PersonOrganiztionlist",
  data() {
    return {
      loading: false,
      loadingText: "加载中...",
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      options: [],
      selectData: null,
      organizationType: null,
      name: null,
    };
  },
  created: function() {
    this.basedatabind().then(() => {
      this.search();
    });
  },
  methods: {
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let searchInfo = {
        organizationType: this.organizationType,
        name: this.name,
        size: this.pageSize,
        current: this.currentPage,
      };
      this.loading = true;
      this.loadingText = "加载中...";
      list(searchInfo)
        .then(r => {
          r = r.data;
          this.tableData = r.records;
          this.total = r.total;
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    clearsearch() {
      this.organizationType = null;
      this.name = null;
    },
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          getDictionary('organization_type'),
        ])
        .then(r => {
          this.options = r[0].data.records;

          this.loading = false;

          return r;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    //编辑按钮
    editClick(index, { id }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        query: {
          id,
          type: "edit"
        }
      });
    },
    //查看详细
    handleClick(index, { id }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        query: {
          id,
          type: "search"
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/PersonOrganiztioninfo",
        query: {
          id: null,
          type: "edit"
        }
      });
    },
    //组织结构有人员存在，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        let { organizationType, id } = selectData[i]
        personList({
            belongDeptType: organizationType,
            belongDeptId: id,
            PageSize: 1,
            PageIndex: 1,
          })
          .then(r => {
            var data = r.data.records;
            if (data.length > 0) {
              this.$message.error(
                selectData[i].name +
                  "有人员存在，请先删除完人员才能删除组织机构"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    //批量删除
    onbatchDel() {
      if (
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          const selectData = this.selectData;
          const count = selectData.length;
          // 清除 所有勾选项
          this.$refs.multipleTable.clearSelection();
          if (count > 0) {
            const that = this;
            that.canDelete(selectData, function(data) {
              const index = data.findIndex(item => item.isDelete == false);
              if (index == -1 && data.length == count) {
                let ids = selectData.map(item =>item.id)
                that.delete(ids.join(','))
              } else {
                return;
              }
            });
          }
        });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        const that = this;
        this.canDelete([row], function(data) {
          const index = data.findIndex(item => item.isDelete == false);
          if (index != -1) {
            return;
          } else {
            that.delete(row.id)
          }
        });
      });
    },
    delete(idList){
      this.loading = true;
      this.loadingText = '删除中...';
      remove({idList}).then(r => {
        r = r.data;
        if (r) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败!"
          });
        }
        this.loading = false;
        this.search();
      })
      .catch(e => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  }
};
</script>